import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonComponent } from "../../common/common-component";
import { interval, merge, mergeMap, Subscription, tap, timer } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../../common/service/config.service";
import { environment } from "../../../environments/environment";
import { ImageSliderComponent } from "../../component/image-slider/image-slider.component";
import { NgForOf, NgIf } from "@angular/common";
import { NotificationService } from "../../common/service/notification.service";
import { ContentBlockComponent } from "../../component/content-block/content-block.component";

@Component({
  selector: 'section#gallery10.gallery',
  standalone: true,
  imports: [
    ImageSliderComponent,
    NgForOf,
    NgIf,
    ContentBlockComponent
  ],
  templateUrl: './gallery10.component.html',
})
export class Gallery10Component extends CommonComponent implements OnInit, OnDestroy {

  private subscription: Subscription | undefined;
  private wsSubscription: Subscription | undefined;
  protected override limit = 27;
  public assets: Array<{ url: string }> = [];

  constructor(
    private httpClient: HttpClient,
    private notificationService: NotificationService,
    private configService: ConfigService
  ) {
    super();
  }

  ngOnInit(): void {

    this.subscription =  this.configService.config$.pipe(
      tap(config => this.config = config),
      mergeMap(() => merge(timer(50), interval(30000))),
      mergeMap(() => this.httpClient.post<Array<{assets: Array<any>, id: string, createdAt: Date, status: string}>>(environment.api_v2_url + '/gallery?random=1&limit=' + this.limit, { event_ids: [this.config.id] })),
    ).subscribe((items: Array<{assets: Array<any>, id: string, createdAt: Date, status: string}>) => {
      this.populateGallery(items);
      this.wsSubscription = this.notificationService.connect(this.config.id).asObservable().subscribe(() => {
        window.location.reload();
      });
    });
  }

  protected override populateGallery(items: Array<{ assets: Array<any>, id: string, createdAt: Date, status: string, interval?: number }>) {


    let updated = false;
    let intersection = this.jobs.filter(job => items.map(i => i.id).includes(job.id));

    // console.log('intersection', intersection.length);

    items.filter(item => ! intersection.map(i => i.id).includes(item.id)).forEach(item => {
      // console.log('new item', item);
      item.interval = Math.floor(Math.random() * 10000) + 10000; // between 10 and 20 seconds
      this.jobs.unshift(item);
      if(this.jobs.length > this.limit) {
        this.jobs.pop();
      }
      updated = true;
    });

    if(updated) {
      this.jobs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      for(let job of this.jobs) {
        for(let asset of job.assets) {
          if(asset.assetType === 'output') {
            this.assets.push(asset);
          }
        }
      }
    }

    // console.log('items', items.length, 'jobs', this.jobs.length, 'assets', this.assets.length);
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
